module.exports = __webpack_public_path__ + "static/media/user-2.e28d0a60.png";